import ViewsRouter from '@/views/ViewsRouter.vue'
import ViewsAddressVerified from '@/views/address/ViewsAddressVerified.vue';
import {RouteRecordRaw} from 'vue-router';

export default [{
    path: '/address',
    name: 'address-parent',
    component: ViewsRouter,
    children: [{
        path: 'verified',
        name: 'address.verified',
        component: ViewsAddressVerified
    }]
}] as RouteRecordRaw[]
